module.exports = __webpack_public_path__ + "static/media/p-r~bmHQgEnO.e97b001a.svg";